import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const copyPoll = (data) => {
  return apiRequestType(apiTypes.POST, apiConstants.SOCIAL.COPY_POLL, data);
};

export default copyPoll;
